module.exports = __webpack_public_path__ + "static/media/Principios_de_base_de_datos_MySQL.9751b44f.png";